export const photos = [
  // Current News
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1675366950/T_P%20Site/New%202022-23/IMG-20221225-WA0060_zmytr2.jpg",
    width: 3,
    height: 4,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1675366950/T_P%20Site/New%202022-23/IMG-20230116-WA0002_brilfb.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1675366949/T_P%20Site/New%202022-23/IMG-20230117-WA0002_ztk4t5.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1675366949/T_P%20Site/New%202022-23/IMG-20230120-WA0005_had44e.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1675366948/T_P%20Site/New%202022-23/IMG-20230114-WA0002_pdj70j.jpg",
    width: 3,
    height: 4,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1675366948/T_P%20Site/New%202022-23/IMG-20230201-WA0004_gq03wn.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1675366948/T_P%20Site/New%202022-23/IMG-20221225-WA0059_vsrgll.jpg",
    width: 3,
    height: 4,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1675366747/T_P%20Site/New%202022-23/Hindustan_SAE_Aerothon_sutxpx.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1675366746/T_P%20Site/New%202022-23/TNP_In_News_deqmea.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1675366739/T_P%20Site/New%202022-23/News_nmxqda.png",
    width: 3,
    height: 4,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1675366738/T_P%20Site/New%202022-23/News_14_Nov_f5bjdq.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1675366737/T_P%20Site/New%202022-23/9_Dec_News_fpeyvn.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1675366737/T_P%20Site/New%202022-23/30_Nov_News_ujucfs.jpg",
    width: 4,
    height: 3,
  },

  // Old News
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1658590462/T_P%20Site/In%20News/Picture15_gf2beu.png",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1658590462/T_P%20Site/In%20News/Picture1_xjpco2.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1658590461/T_P%20Site/In%20News/Picture14_xrt1su.png",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1658590461/T_P%20Site/In%20News/Picture11_or5gg0.png",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1658590461/T_P%20Site/In%20News/Picture13_wzwwn5.png",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1658590461/T_P%20Site/In%20News/Picture12_pjjerw.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1658590461/T_P%20Site/In%20News/Picture8_cxle7b.png",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1658590461/T_P%20Site/In%20News/Picture9_ji9acf.png",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1658590461/T_P%20Site/In%20News/Picture10_taelo5.png",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1658590460/T_P%20Site/In%20News/Picture5_hszqz4.png",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1658590460/T_P%20Site/In%20News/Picture6_e3b8al.png",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1658590460/T_P%20Site/In%20News/Picture7_xfdabw.png",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1658590460/T_P%20Site/In%20News/Picture2_opcj69.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1658590460/T_P%20Site/In%20News/Picture4_yxvqzu.png",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1658590460/T_P%20Site/In%20News/Picture3_mk7vht.jpg",
    width: 4,
    height: 3,
  },
];
